import { useSpring, animated } from "@react-spring/web";
import React, { useCallback, useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { useAuth } from "../authContext";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { AccountCircle } from "@mui/icons-material";
import AdminSidebar from "./sidebar";
import { DataGrid } from "@mui/x-data-grid";
import { Alert, Autocomplete, Backdrop, Box, Button, Container, CssBaseline, Drawer, FormHelperText, Grid, IconButton, InputAdornment, Modal, Snackbar, SnackbarContent, TextareaAutosize, TextField, Toolbar, Typography } from "@mui/material";
import TagService from "../services/manager/tagService";
import BannerService from "../services/manager/bannerService";
import CloseIcon from '@mui/icons-material/Close';
import { useDropzone } from "react-dropzone";
import noImage from "../assets/no-image.png";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import ImageSortableList from "./components/imageSortableList";
import AdminNavigation from "./adminNavigation";
import LiqueModal from "../customer/components/liqueModal";
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { btnStyleContrast, subHeaderStyleContrast, textSmallStyleContrast, textStyleContrast, headerStyleContrast } from "../helper/style";
import { compressImageWebp } from "../helper/helperFunctions";

const RootContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export default function ReviewBanner() {
  const [showSuccess, setShowSuccess] = useState(false);
  const [msgSuccess, setmsgSuccess] = useState("");
  const [showError, setShowError] = useState(false);
  const [msgError, setMsgError] = useState();
  const [openEdit, setOpenEdit] = useState(false);
  const [openEditBig, setOpenEditBig] = useState(false);
  const [errors, setErrors] = useState({});
  
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [updateId, setUpdateId] = useState("");
  const [images, setImages] = useState([]);
  const [oldImages, setOldImages] = useState([]);
  const [tag, setTag] = useState(null);
  const [runningText, setRunningText] = useState([]);
  const [bannerType, setBannerType] = useState("");
  const [listTagSecondary, setListTagSecondary] = useState([]);
  const [listBanner, setListBanner] = useState([]);
  const [listBannerFiltered, setListBannerFiltered] = useState([]);
  const [showMsgImage, setShowMsgImage] = useState(false);
  const [msgImageError, setMsgImageError] = useState("");
  const [search, setSearch] = useState("");
  const [loadingImage, setLoadingImage] = useState(false);

  const imageUrl = process.env.REACT_APP_IMAGE_URL

  const handleOpenEdit = (row) => {
    setTitle(row.title);
    setUpdateId(row.id);
    setDescription(row.description);
    setBannerType(row.bannerType);
    if (row.runningText) {
      setRunningText(row.runningText);
    }
    if (row.tagSecondary) {
      setTag(listTagSecondary.find(tags => tags.id === row.tagSecondary.id));
    }
    setOldImages(row.images || []);
    
    if (row.bannerType === 'small') {
      setOpenEdit(true);
    } else {
      setOpenEditBig(true);
    }
  };

  const handleCloseEdit = () => {
    if (bannerType === 'small') {
      setOpenEdit(false);
    } else {
      setOpenEditBig(false);
    }

    setBannerType("");
    setUpdateId("");
    setTitle("");
    setDescription("");
    setRunningText([]);
    setImages([]);
    setOldImages([]);
    setTag(null)
  };
  
  const handleDeleteImage = (name) => {
    setOldImages(oldImages.filter(image => image !== name));
  }

  const activateSuccess = () => {
    setShowSuccess(true);
    setTimeout(() => {
      setShowSuccess(false);
    }, 5000);
  };

  const activateError = () => {
    setShowError(true);
    setTimeout(() => {
      setShowError(false);
    }, 5000);
  };

  const validateSmall = () => {
    let tempErrors = {};

    if (runningText.length <= 0) {
      tempErrors.runningText = "Running text wajib diisi";
    } else if (runningText.length === 1 && runningText[0] === "") {
      tempErrors.runningText = "Running text wajib diisi";
    }

    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  const validateBig = () => {
    let tempErrors = {};

    if (!title) {
      tempErrors.title = "Nama harus diisi";
    }

    if (!tag) {
      tempErrors.tag = "Tag harus diisi";
    }

    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  const handleRemoveRunningText = (index) => {
    const text = [...runningText];
    text.splice(index, 1);
    setRunningText(text);
  }

  const handleChangeRunningText = (updatedText, index) => {
    const text = [...runningText];
    text[index] = updatedText;
    setRunningText(text);
  }

  const handleAddRunningText = () => {
    const text = [...runningText];
    text.push("");
    setRunningText(text);
  }

  
  const onDrop = useCallback(
    (acceptedFiles) => {
      // Handle the files
      const validFiles = acceptedFiles.filter((file) =>
        /\.(jpg|jpeg|png|gif)$/i.test(file.name)
      );
      console.log(acceptedFiles);
      if (validFiles.length > 0) {
        setShowMsgImage(false);
        setLoadingImage(true);
        // const details = acceptedFiles.map(file => ({
        //     path: file.path || ""
        // }));
        // const fileNames = details.map(file => file.path);
        // setFiles(fileNames);
        const filePreviews = validFiles.map(async (file) => {
          const compresedImage = await compressImageWebp(file);

          const reader = new FileReader();
          reader.readAsDataURL(compresedImage);
          return new Promise((resolve) => {
            reader.onload = () => {
              resolve({
                path: compresedImage.name,
                preview: reader.result,
                originalFile: compresedImage,
              });
            };
          });
        });

        Promise.all(filePreviews)
          .then((images) => {
            setImages(images);
          })
          .catch((error) => {
            console.error("Error reading files:", error);
          })
          .finally(() => {
            setLoadingImage(false);
          });;
      } else {
        setShowMsgImage(true);
        setMsgImageError(
          "Invalid file types detected. Please upload only image files."
        );
        console.error(
          "Invalid file types detected. Please upload only image files."
        );
      }
    },
    [setImages]
  );
  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop });

  const getAllTag = async () => {
    try {
      const response = await TagService.getTagList();
      if (response) {
        const data = response.data.tagModelList;
        setListTagSecondary(data);
      }
    } catch (error) {
      console.error(error);
      setMsgError("Error while fetching list tags");
      activateError();
    }
  };

  const getAllBanner = async () => {
    try {
      const response = await BannerService.getAllBanner();
      if (response) {
        const data = response.data.outputSchema;
        setListBanner(data);
        setListBannerFiltered(data);
      }
    } catch (error) {
      console.error(error);
      setMsgError("Error while fetching list banners");
      activateError();
    }
  }

  const updateSmallBanner = async (e) => {
    e.preventDefault();
    if (!validateSmall()) {
      return;
    }

    try {
      const updatedRunningText = [];
      runningText.forEach(text => {
        if (text !== "" && text !== null) {
          updatedRunningText.push(text)
        }
      })

      const response = await BannerService.updateBanner(
        updateId,
        updatedRunningText, "", "", 0, [], []
      )

      if (response) {
        setmsgSuccess("Update Banner Success");
        activateSuccess();
        getAllBanner();
        handleCloseEdit();
      }

    } catch (error) {
      console.error(error);
      setMsgError("Error while update banners");
      activateError();
    }
  }

  const updateBigBanner = async (e) => {
    e.preventDefault();
    if (!validateBig()) {
      return;
    }
    
    try {

      const response = await BannerService.updateBanner(
        updateId,
        [], 
        title, 
        description, 
        tag.id, 
        images,
        oldImages
      )

      if (response) {
        setmsgSuccess("Update Banner Success");
        activateSuccess();
        getAllBanner();
        handleCloseEdit();
      }

    } catch (error) {
      console.error(error);
      setMsgError("Error while update banners");
      activateError();
    }
  }

  useEffect(() => {
    getAllTag();
    getAllBanner();
  }, []);

  const searchTimeout = useRef(null);
  useEffect(() => {
    if (listBanner.length > 0) {
      if (searchTimeout.current) {
        clearTimeout(searchTimeout.current);
      }
  
      searchTimeout.current = setTimeout(() => {
        const filtered = listBanner.filter(banner => {
          let title = (banner.title || '').toLowerCase();
          return title.includes(search);
        });
  
        setListBannerFiltered(filtered);
      }, 500);
      return () => clearTimeout(searchTimeout.current);
    }
  }, [search]);

  return (
    <Box>
      <CssBaseline />
      <AdminNavigation />
      <Container component="main"  maxWidth="xl">
        <RootContainer>
          <Snackbar
            anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
            open={showSuccess}
            autoHideDuration={3000}
            onClose={() => setShowSuccess(false)}
          >
            <SnackbarContent
              sx={{ backgroundColor: "#19B600" }} 
              message={msgSuccess}/>
          </Snackbar>
    
          <Snackbar
            anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
            open={showError}
            autoHideDuration={3000}
            onClose={() => setShowError(false)}
          >
            <SnackbarContent 
              sx={{ backgroundColor: "#E50B0B" }} 
              message={msgError}/>
          </Snackbar>

          <Grid container spacing={1} alignItems="center" marginBottom={2}>
            <Grid item xs={12} md={8}>
              <Typography sx={{ ...headerStyleContrast }}>
                Kelola Theme
              </Typography>
            </Grid>
            <Grid item xs={12} md={4}>
              <TextField
                fullWidth
                value={search}
                placeholder="Cari Banner..."
                onChange={(e) => setSearch(e.target.value)}
                InputProps={{ 
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchOutlinedIcon />
                    </InputAdornment>
                  )
                }}
              />
            </Grid>
          </Grid>

          <Box sx={{ width: "100%" }}>
            {
              listBannerFiltered.map(banner => (
                <Box  
                  key={banner.id}
                  sx={{ background: "white", borderRadius: "16px", padding: "16px", marginBottom: "20px", boxShadow: "2px 2px 10px rgba(0, 0, 0, .2)" }}
                >
                  <Grid container spacing={2}>
                    <Grid item xs={4} md={1}>
                      <Box sx={{ width: "100%" }}>
                        <img
                          src={
                            banner.images?.length <= 0 || banner.images == null
                            ? noImage
                            : `${imageUrl}${banner.images[0]}`
                          }
                          alt={banner.title}
                          style={{
                            width: "100%",
                            aspectRatio: "1 / 1",
                            objectFit: "cover",
                            marginRight: "3%",
                            borderRadius: "8px"
                          }}
                        ></img>
                      </Box>
                    </Grid>
                    <Grid item xs={8} md={11}>
                      <Typography sx={{ ...textStyleContrast, fontWeight: "500" }}>
                        {banner.title}
                      </Typography>
                      <Typography sx={{ ...textSmallStyleContrast }}>
                        {banner.description}
                      </Typography>
                      <Typography sx={{ ...textSmallStyleContrast }}>
                        Urutan {banner.displayOrder} • Ke Halaman {banner.tagSecondary?.title}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} display="flex" justifyContent="end" gap="10px">
                      <Button 
                        sx={{ ...btnStyleContrast, borderRadius: "50px", width: "120px" }}
                        endIcon={<EditOutlinedIcon />}
                        onClick={() => handleOpenEdit(banner)}
                      >
                        Edit
                      </Button>
                    </Grid>
                  </Grid>
                </Box>
              ))
            }
          </Box>
        </RootContainer>

        <LiqueModal open={openEdit} onClose={handleCloseEdit}>
          <form>
            <Grid container spacing={3}>
              {
                runningText.map((text, index) => (
                  <React.Fragment key={index}>
                    <Grid item xs={10}>
                      <Typography>Running Text {index + 1} *</Typography>
                      <TextField
                        fullWidth
                        autoComplete="off"
                        value={text}
                        error={!!errors.runningText}
                        helperText={errors.runningText}
                        FormHelperTextProps={{ sx: { color: "red" } }}
                        onChange={(e) => handleChangeRunningText(e.target.value, index)}
                      />
                    </Grid>
                    <Grid item xs={2}>
                      <IconButton style={{ color: "black", marginTop: "30px" }} 
                        disabled={runningText.length <= 1}
                        onClick={() => handleRemoveRunningText(index)}>
                        <CloseIcon></CloseIcon>
                      </IconButton>
                    </Grid>
                  </React.Fragment>
                ))
              }
              
              <Grid item xs={12}>
                <Button sx={{ color: "black" }} onClick={handleAddRunningText}>
                  + Tambah Text
                </Button>
              </Grid>
              
              
              <Grid item xs={12}>
                <Button
                  variant="contained"
                  onClick={updateSmallBanner}
                  fullWidth
                  style={{ backgroundColor: "black", color: "white" }}
                >
                  Submit
                </Button>
              </Grid>
            </Grid>
          </form>
        </LiqueModal>

        <LiqueModal open={openEditBig} onClose={handleCloseEdit}>
          <form>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Typography>Judul Banner *</Typography>
                <TextField
                  fullWidth
                  autoComplete="off"
                  value={title}
                  error={!!errors.title}
                  helperText={errors.title}
                  FormHelperTextProps={{ sx: { color: "red" } }}
                  onChange={(e) => setTitle(e.target.value)}
                />
              </Grid>
              <Grid item xs={12}>
                <Typography>Deskripsi</Typography>
                <TextareaAutosize
                  style={{ width: "100%" }}
                  minRows={3}
                  autoComplete="off"
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                />
                {!!errors.description ? (
                  <FormHelperText sx={{ color: "red" }}>
                    {errors.description}
                  </FormHelperText>
                ) : null}
              </Grid>
              
              <Grid item xs={12}>
                <Typography>Diarahkan ke halaman *</Typography>
                <Autocomplete
                  options={listTagSecondary}
                  getOptionLabel={(option) => option.title}
                  value={{...tag}}
                  isOptionEqualToValue={(option, value) => {
                    return option.id === value.id
                  }}
                  renderInput={(params) => (
                    <TextField {...params} fullWidth />
                  )}
                  disableClearable
                  onChange={(event, newValue) => setTag(newValue)} />

                {!!errors.tag ? (
                  <FormHelperText sx={{ color: "red" }}>
                    {errors.tag}
                  </FormHelperText>
                ) : null}
              </Grid>

              <Grid item xs={12}>
                <Box
                  {...getRootProps()}
                  sx={{
                    border: "2px dashed #aaa",
                    borderRadius: "4px",
                    padding: "20px",
                    textAlign: "center",
                    cursor: "pointer",
                    backgroundColor: isDragActive ? "#f0f0f0" : "#fafafa",
                    transition: "background-color 0.2s",
                  }}
                >
                  <input {...getInputProps()} />
                  {isDragActive ? (
                    <Typography>Drop the files here...</Typography>
                  ) : (
                    <Typography>
                      Drag 'n' drop some files here, or click to select
                      files
                    </Typography>
                  )}
                </Box>
                {!showMsgImage && (
                  <Box
                    mt={2}
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      flexWrap: "wrap",
                    }}
                  >
                    {images.map((file, index) => (
                      <Box key={index} mb={2} mr={2}>
                        <Typography>{file.path}</Typography>
                        <img
                          src={file.preview}
                          alt={file.path}
                          style={{ maxWidth: "70%", maxHeight: "100px" }}
                        />
                      </Box>
                    ))}
                  </Box>
                )}
                {showMsgImage && (
                  <Typography sx={{ color: "red" }}>
                    {msgImageError}
                  </Typography>
                )}
                {
                  loadingImage && (
                    <Typography>
                      Sedang mengkompres gambar, mohon menunggu...
                    </Typography>
                  )
                }
              </Grid>

              <Grid item xs={12}>
                <Typography>Gambar Sekarang</Typography>
                  <DndProvider backend={HTML5Backend}>
                    <ImageSortableList 
                      images={oldImages}
                      setImages={setOldImages}
                      alt={title}
                      deleteItem={handleDeleteImage}
                    />
                  </DndProvider>
                <Grid container spacing={2} marginTop={0}>
                  {
                    oldImages.length <= 0 ? (
                      <Grid item xs={12} textAlign="center">Belum ada Gambar</Grid>
                    ) : null
                  }
                </Grid>
              </Grid>

              <Grid item xs={12}>
                <Button
                  variant="contained"
                  onClick={updateBigBanner}
                  fullWidth
                  style={{ backgroundColor: "black", color: "white" }}
                >
                  Submit
                </Button>
              </Grid>
            </Grid>
          </form>
        </LiqueModal>

      </Container>
    </Box>
  )
}